"use client";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import { Col, Form, Row, Select } from "antd";

const Accounting = (props) => {
  const {
    onFinish,
    form,
    initialValues,
    assetAccountOptions,
    incomeAccountOptions,
  } = props;

  return (
    <div>
      <h1 style={{ fontSize: "24px", fontWeight: "bold", margin: 0,  marginBottom: "24px" }}>
        Accounting
      </h1>

      <Form
        className="custom-form"
        layout="vertical"
        onFinish={onFinish}
        form={form}
        initialValues={initialValues}
        style={{ marginY: 30 }}
      >
        <Row
          style={{
            background: "#F9FAFB",
            padding: "12px 24px",
            borderRadius: "8px 8px 0 0",
            marginBottom: "8px",
          }}
        >
          <Col span={8}>
            <span style={{ color: "#344054", fontWeight: 500 }}>Events</span>
          </Col>
          <Col span={8}>
            <span style={{ color: "#344054", fontWeight: 500 }}>Debit</span>
          </Col>
          <Col span={8}>
            <span style={{ color: "#344054", fontWeight: 500 }}>Credit</span>
          </Col>
        </Row>

        <Row justify="center" align="middle">
          <Col span={8}>
            <span
              style={{
                fontSize: "16px",
                lineHeight: "24px",
                paddingBottom: 30,
                display: "block",
              }}
            >
              Investment - Deal Booking
            </span>
          </Col>
          <Col span={8}>
            <Form.Item
              name={["investmentGL", 0]}
              rules={[
                {
                  required: true,
                  message: "Please select a GL account",
                },
              ]}
            >
              <Select
                placeholder="Select GL Account"
                style={{ width: "90%", height: "44px" }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={assetAccountOptions}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name={["investmentGL", 1]}
              rules={[
                {
                  required: true,
                  message: "Please select a GL account",
                },
              ]}
            >
              <Select
                placeholder="Select GL Account"
                style={{ width: "90%", height: "44px" }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={assetAccountOptions}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row justify="center" align="middle">
          <Col span={8}>
            <span
              style={{
                fontSize: "16px",
                lineHeight: "24px",
                paddingBottom: 30,
                display: "block",
              }}
            >
              Interest Accrual Posting
            </span>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              name={["accruedInterestGL", 0]}
              rules={[
                {
                  required: true,
                  message: "Please select a GL account",
                },
              ]}
            >
              <Select
                placeholder="Select GL Account"
                style={{ width: "90%", height: "44px" }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={assetAccountOptions}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              name={["accruedInterestGL", 1]}
              rules={[
                {
                  required: true,
                  message: "Please select a GL account",
                },
              ]}
            >
              <Select
                placeholder="Select GL Account"
                style={{ width: "90%", height: "44px" }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={assetAccountOptions}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row justify="center" align="middle">
          <Col span={8}>
            <span
              style={{
                fontSize: "16px",
                lineHeight: "24px",
                paddingBottom: 30,
                display: "block",
              }}
            >
              Investment - Redemption (Customer Payable)
            </span>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              name={["settlementGL", 0]}
              rules={[
                {
                  required: true,
                  message: "Please select a GL account",
                },
              ]}
            >
              <Select
                placeholder="Select GL Account"
                style={{ width: "90%", height: "44px" }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={assetAccountOptions}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              name={["settlementGL", 1]}
              rules={[
                {
                  required: true,
                  message: "Please select a GL account",
                },
              ]}
            >
              <Select
                placeholder="Select GL Account"
                style={{ width: "90%", height: "44px" }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={assetAccountOptions}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row justify="center" align="middle">
          <Col span={8}>
            <span
              style={{
                fontSize: "16px",
                lineHeight: "24px",
                paddingBottom: 30,
                display: "block",
              }}
            >
              Income Interest Posting
            </span>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              name={["interestIncomeGL", 0]}
              rules={[
                {
                  required: true,
                  message: "Please select a GL account",
                },
              ]}
            >
              <Select
                placeholder="Select GL Account"
                style={{ width: "90%", height: "44px" }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={incomeAccountOptions}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              name={["interestIncomeGL", 1]}
              rules={[
                {
                  required: true,
                  message: "Please select a GL account",
                },
              ]}
            >
              <Select
                placeholder="Select GL Account"
                style={{ width: "90%", height: "44px" }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={incomeAccountOptions}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row justify="center" align="middle">
          <Col span={8}>
            <span
              style={{
                fontSize: "16px",
                lineHeight: "24px",
                paddingBottom: 30,
                display: "block",
              }}
            >
              Income Fees Posting
            </span>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              name={["feeGL", 0]}
              rules={[
                {
                  required: true,
                  message: "Please select a GL account",
                },
              ]}
            >
              <Select
                placeholder="Select GL Account"
                style={{ width: "90%", height: "44px" }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={incomeAccountOptions}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              name={["feeGL", 1]}
              rules={[
                {
                  required: true,
                  message: "Please select a GL account",
                },
              ]}
            >
              <Select
                placeholder="Select GL Account"
                style={{ width: "90%", height: "44px" }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={incomeAccountOptions}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row justify="center" align="middle">
          <Col span={8}>
            <span
              style={{
                fontSize: "16px",
                lineHeight: "24px",
                paddingBottom: 30,
                display: "block",
              }}
            >
              Income Penalty Posting
            </span>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              name={["penaltyGL", 0]}
              rules={[
                {
                  required: true,
                  message: "Please select a GL account",
                },
              ]}
            >
              <Select
                placeholder="Select GL Account"
                style={{ width: "90%", height: "44px" }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={incomeAccountOptions}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              name={["penaltyGL", 1]}
              rules={[
                {
                  required: true,
                  message: "Please select a GL account",
                },
              ]}
            >
              <Select
                placeholder="Select GL Account"
                style={{ width: "90%", height: "44px" }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={incomeAccountOptions}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Accounting;
